'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _genericMaterialAreas = require('../actions/genericMaterialAreas');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialAreas),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialArea),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editGenericMaterialArea),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createGenericMaterialArea),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialAreasRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialAreaRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editGenericMaterialAreaRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createGenericMaterialAreaRequest);

function fetchGenericMaterialAreas(_ref) {
    var genericMaterialId = _ref.genericMaterialId;
    var url, response, genericMaterialAreas;
    return regeneratorRuntime.wrap(function fetchGenericMaterialAreas$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    url = '/genericmaterialareas';


                    if (genericMaterialId !== undefined && genericMaterialId !== null) {
                        url = url + '?genericMaterialId=' + genericMaterialId;
                    }

                    _context.next = 5;
                    return (0, _effects.call)(_api.request, 'get', url);

                case 5:
                    response = _context.sent;
                    genericMaterialAreas = response.data.sort(function (a, b) {

                        if (a.name < b.name) {
                            return -1;
                        }
                        return 1;
                    });
                    _context.next = 9;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.fetchGenericMaterialAreasSucceeded(genericMaterialAreas));

                case 9:
                    _context.next = 15;
                    break;

                case 11:
                    _context.prev = 11;
                    _context.t0 = _context['catch'](0);
                    _context.next = 15;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.fetchGenericMaterialAreaFailed(_context.t0));

                case 15:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 11]]);
}

function fetchGenericMaterialArea(_ref2) {
    var id = _ref2.id;
    var response, genericMaterialArea;
    return regeneratorRuntime.wrap(function fetchGenericMaterialArea$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/genericmaterialareas/' + id);

                case 3:
                    response = _context2.sent;
                    genericMaterialArea = response.data;
                    _context2.next = 7;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.fetchGenericMaterialAreaSucceeded(genericMaterialArea));

                case 7:
                    _context2.next = 13;
                    break;

                case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 13;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.fetchGenericMaterialAreaFailed(_context2.t0));

                case 13:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 9]]);
}

function editGenericMaterialArea(_ref3) {
    var genericMaterialArea = _ref3.genericMaterialArea;
    var response;
    return regeneratorRuntime.wrap(function editGenericMaterialArea$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/genericmaterialareas/' + genericMaterialArea.id, genericMaterialArea);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.editGenericMaterialAreaSucceeded(response.data));

                case 6:
                    _context3.next = 12;
                    break;

                case 8:
                    _context3.prev = 8;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 12;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.createGenericMaterialAreaFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 8]]);
}

function createGenericMaterialArea(_ref4) {
    var genericMaterialArea = _ref4.genericMaterialArea;
    var response;
    return regeneratorRuntime.wrap(function createGenericMaterialArea$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/genericmaterialareas/', genericMaterialArea);

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.createGenericMaterialAreaSucceeded(response.data));

                case 6:
                    _context4.next = 12;
                    break;

                case 8:
                    _context4.prev = 8;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 12;
                    return (0, _effects.put)(_genericMaterialAreas.actionCreators.createGenericMaterialAreaFailed(_context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 12:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 8]]);
}

function fetchGenericMaterialAreasRequest() {
    return regeneratorRuntime.wrap(function fetchGenericMaterialAreasRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterialAreas.actionTypes.FETCH_GENERIC_MATERIAL_AREAS_REQUEST, fetchGenericMaterialAreas);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchGenericMaterialAreaRequest() {
    return regeneratorRuntime.wrap(function fetchGenericMaterialAreaRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterialAreas.actionTypes.FETCH_GENERIC_MATERIAL_AREA_REQUEST, fetchGenericMaterialArea);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editGenericMaterialAreaRequest() {
    return regeneratorRuntime.wrap(function editGenericMaterialAreaRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterialAreas.actionTypes.EDIT_GENERIC_MATERIAL_AREA_REQUEST, editGenericMaterialArea);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createGenericMaterialAreaRequest() {
    return regeneratorRuntime.wrap(function createGenericMaterialAreaRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterialAreas.actionTypes.CREATE_GENERIC_MATERIAL_AREA_REQUEST, createGenericMaterialArea);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchGenericMaterialAreasRequest, fetchGenericMaterialAreaRequest, editGenericMaterialAreaRequest, createGenericMaterialAreaRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/genericMaterialAreas.js
// module id = 2239
// module chunks = 0